import { EffectCallback, useEffect, useRef } from 'react';

/**
 * Custom hook that runs the provided function only on the initial mount of the component.
 * @param effect The function to be executed on mount.
 */
export const useMount = (effect: EffectCallback) => {
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      effect();
      isMounted.current = true;
    }

    return () => {
      isMounted.current = false;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
